module.exports = __webpack_public_path__ + "static/media/cross-new-1.6c998b72.svg";